import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import { OptionCode } from '../../../enums';
import useQuery from '../../../useQuery';
export const usePrecocityClassOptionsList = ({ enabled }) => {
    const client = useClient();
    const { t } = useIntl();
    const maizySeeds = useQuery(client.seeds.getAll({ optionCode: OptionCode.maizy, hasPrecocityClass: true }), { enabled }).data;
    const precocityClassOptionsList = maizySeeds
        ?.filter((seed) => !isNil(seed.maizyPrecocityClass))
        ?.map((seed) => ({
        label: t(`dss.maizy.legends.precocityClass.${seed.maizyPrecocityClass}`),
        value: seed.id
    })) || [];
    return precocityClassOptionsList;
};
